import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Proxy extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Proxy";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {

    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    return data;
  }
}
